import type { Plugin } from 'vue';
import { unref } from 'vue';

import type { Permission } from '@modules/permissions/utils';
import { usePermissionsStore } from '@modules/permissions/store';

const AppPermissionsPlugin: Plugin = {
  install(app) {
    const { hasPermission } = usePermissionsStore();

    app.config.globalProperties.$hasPermission = (permission: Permission | Permission[]): boolean => unref(hasPermission(permission));
  },
};

export default AppPermissionsPlugin;
